/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserItem
 */
export interface UserItem {
    /**
     * 
     * @type {string}
     * @memberof UserItem
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserItem
     */
    firstName: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserItem
     */
    voiceTypeId?: number | null;
}

/**
 * Check if a given object implements the UserItem interface.
 */
export function instanceOfUserItem(value: object): value is UserItem {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    return true;
}

export function UserItemFromJSON(json: any): UserItem {
    return UserItemFromJSONTyped(json, false);
}

export function UserItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserItem {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'firstName': json['firstName'],
        'voiceTypeId': json['voiceTypeId'] == null ? undefined : json['voiceTypeId'],
    };
}

export function UserItemToJSON(json: any): UserItem {
    return UserItemToJSONTyped(json, false);
}

export function UserItemToJSONTyped(value?: UserItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'firstName': value['firstName'],
        'voiceTypeId': value['voiceTypeId'],
    };
}

